export default Array.isArray
